'use strict';
const i18n = require('i18next');
const ActionNotification = require('./index');

module.exports = ActionNotification.extend({
    getContent: function() {
        return i18n.t('notification:action.start.content');
    }
}, {
    type: 'action:start'
});



// WEBPACK FOOTER //
// ./notify/domain/entity/notification/action/start.js